module.exports = __webpack_public_path__ + "static/img_slideshow_00-abc57645dbc6a2c3cc5f991b4ed1cd7b.jpg";